// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__KvwZv","fieldset":"LoginForm_fieldset__xUd4A","text":"LoginForm_text__75qRf","forgotPw":"LoginForm_forgotPw__SXMQF","error":"LoginForm_error__vCowU"};